import HTTP from './http.service';

export const challengeService = {
  generate,
  results,
  update,
};

async function generate(user, campaign) {    
  return await HTTP.post('challenges/generate', { user, campaign });
}

async function results(challenge) {
  return await HTTP.get(`challenges/results/${challenge}`);
}

async function update(challenge) {
  return await HTTP.post('challenges/update', { ...challenge });
}

